import { Component, DoCheck, OnInit } from '@angular/core';
import { AlertService, AuthenticationService } from '../../_services';
import { DashboardStore } from '../../_services/store';
import { UpgradeStore } from '../../_services/store/upgradeStore.service';

@Component({
  selector: 'app-select-accounts',
  templateUrl: './select-accounts.page.html',
  styleUrls: ['./select-accounts.page.scss'],
})
export class SelectAccountsPage implements OnInit, DoCheck {
  accounts = [];
  upgradedIds = [];
  selectedIds = [];
  currentUserName: string;
  currentUser: string;
  theAccount: string;
  disabled = true;

  constructor(
    private alertService: AlertService,
    private upgradeStore: UpgradeStore,
    private auth: AuthenticationService,
    private dashboardStore: DashboardStore,
  ) {
    this.currentUser = this.auth.currentUserValue;
    this.currentUserName = this.dashboardStore.getCurrentUserName();
  }

  dismissModal() {
    this.alertService.dismissModal();
  }

  selectAccount() {
    this.selectedIds = [];
    const selectedItems = this.accounts.filter(account => account.isChecked);
    selectedItems.forEach(element => {
      if (element.isChecked) {
        this.selectedIds.push(element.id);
      }
    });
    this.upgradeStore.setTempSelectedIds(this.selectedIds);
  }

  proceed() {
    const ids = this.upgradeStore.getTempSelectedIds().filter(
      (id: number) => !this.upgradedIds.includes(id)
    );
    const accountId = this.dashboardStore.getAccountSummary().details.id;
    if (!ids.includes(accountId)) {
      this.upgradeStore.setRequestId('null');
    }
    this.upgradeStore.setSelectedIds(ids);
    this.upgradeStore.setIsProceeded(true);
    this.dismissModal();
  }

  ionViewWillEnter() {
  }


  ngOnInit() {
    this.accounts = this.dashboardStore.getAccounts();
    this.upgradedIds = this.upgradeStore.getUpgradedAccountIds();
    !this.upgradeStore.getTempSelectedIds() ?
    this.upgradeStore.setTempSelectedIds(this.selectedIds) :
    this.upgradeStore.getTempSelectedIds();
    this.accounts.map((account) => {
      Object.assign(account, { isChecked: false });
      if (this.upgradedIds.includes(account.id) ||
         this.upgradeStore.getTempSelectedIds().includes(account.id)) {
        account.isChecked = true;
      }
    });
  }

  ngDoCheck(): void {
    this.disabled = true;
    if (this.upgradeStore.getTempSelectedIds().length > this.upgradedIds.length) {
      this.disabled = false;
    }
  }
}
